import type { TranslationInterface } from '.';

export const UrduLanguage: TranslationInterface = {
  write_a_message_placeholder: 'پیغام لکھیں...',
  your_issue_has_been_resolved: 'آپ کا مسئلہ حل ہو گیا ہے!',
  new_conversation: 'نئی گفتگو',
  welcome_screen_title: 'ہماری سپورٹ چیٹ میں خوش آمدید',
  welcome_screen_description:
    'ہم مدد کے لیے حاضر ہیں! گفتگو شروع کریں اور ہم جلد از جلد آپ سے رابطہ کریں گے۔',
  your_name_placeholder: 'آپ کا نام',
  your_email_placeholder: 'آپ کا ای میل پتہ',
  start_chat_button: 'سپورٹ سے بات کریں',
  start_chat_button_loading: 'جڑ رہا ہے...',
  i_need_more_help: 'مجھے مزید مدد چاہیے',
  this_was_helpful: 'یہ مددگار تھا',
  optional: 'اختیاری',
  no_conversations_yet: 'ابھی تک کوئی گفتگو نہیں',
  back_to_conversations: 'گفتگو پر واپس جائیں',
  closed_conversations: 'بند گفتگو',
  csat_title: 'آپ کی گفتگو کیسی رہی؟',
  csat_submitted_title: 'آپ نے گفتگو کو درجہ دیا',
  csat_feedback_placeholder: 'ہمیں مزید بتائیں... (اختیاری)',
  follow_up_placeholder: 'مزید پوچھیں…',
  companion_layout_label: 'لے آؤٹ',
  companion_layout_floating: 'فلوٹنگ',
  companion_layout_sidebar: 'سائیڈ بار',
  companion_layout_fullscreen: 'مکمل اسکرین',
  companion_close: 'بند کریں',
  companion_history: 'گفتگو کی سرگزشت',
  companion_expand_chat: 'چیٹ پھیلائیں',
  companion_sidebar_dock_label: 'ڈاک',
  companion_sidebar_side_label: 'طرف',
  companion_sidebar_left: 'بائیں',
  companion_sidebar_right: 'دائیں',
  companion_resize_chat: 'چیٹ کا سائز تبدیل کریں',
  scroll_to_bottom: 'نیچے تک اسکرول کریں',
  thinking: 'سوچ رہا ہے…',
  running: 'جاری ہے…',
  steps: 'مراحل',
  step_arguments: 'آرگیومنٹس',
  step_result: 'نتیجہ',
  attach_files:
    'تصاویر، ویڈیوز، PDF یا اسپریڈشیٹس منسلک کریں (زیادہ سے زیادہ حجم 25 MB)',
  mark_page_active:
    'نشان لگانے کے لیے صفحے پر کسی چیز پر کلک کریں — منسوخ کرنے کے لیے Esc دبائیں',
  mark_page: 'صفحے پر کسی چیز کے بارے میں پوچھنے کے لیے اس پر نشان لگائیں',
  stop_response: 'جواب روکیں',
  copy_reply: 'جواب کاپی کریں',
  mentions_empty: 'کوئی مماثلت نہیں',
  copied: 'کاپی ہو گیا',
  send_message: 'پیغام بھیجیں',
  upload_failed: 'اپ لوڈ ناکام: {error}',
  remove_attachment: 'منسلکہ ہٹائیں',
  json_no_items: 'کوئی آئٹم نہیں',
  json_no_data: 'کوئی ڈیٹا نہیں',
  json_no_chart_data: 'چارٹ کے لیے کوئی ڈیٹا نہیں',
  json_unsupported: 'تعاون یافتہ نہیں: {type}',
  json_see_less: 'کم دیکھیں',
  json_phone_agent: 'فون ایجنٹ',
  json_phone_agent_test: 'ویب کے ذریعے آزمائیں',
  page_context_remove: 'صفحے کا سیاق ہٹائیں',
  json_see_more: 'مزید {count} دیکھیں',
  queued_label: '{count} قطار میں',
  remove_queued_message: 'پیغام کو قطار سے ہٹائیں',
  send_queued_now: 'قطار میں موجود پیغامات ابھی بھیجیں',
  turn_failed_message: 'کچھ غلط ہو گیا اور جواب موصول نہیں ہوا۔',
  turn_failed_retry: 'دوبارہ کوشش کریں',
  page_mark_hint: 'نشان لگانے کے لیے کسی چیز پر کلک کریں',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'خانہ',
  page_mark_shape_circle: 'دائرہ',
  page_mark_shape_arrow: 'تیر',
  page_mark_shape_bracket: 'قوس',
  page_mark_shape_underline: 'خط کشیدہ',
  page_mark_shape_highlight: 'نمایاں',
  page_mark_shape_strike_through: 'کاٹنے کی لکیر',
  page_mark_shape_crossed_off: 'ضرب کا نشان',
  page_mark_shape_aria: 'نشان کی شکل: {shape}',
  page_mark_note_placeholder: 'نوٹ شامل کریں… (منسلک کرنے کے لیے Enter دبائیں)',
  page_mark_attach: 'نشان منسلک کریں',
  page_mark_remove: '{label} ہٹائیں',
  page_mark_region: 'نشان زدہ علاقہ',
  page_mark_default_message: 'یہ کیا ہے؟',
  file_rejected: 'فائل کی قسم تعاون یافتہ نہیں ہے یا فائل بہت بڑی ہے۔',
  dictate: 'بول کر لکھیں',
  stop_dictation: 'ڈکٹیشن روکیں',
  dictation_mic_blocked: 'بول کر لکھنے کے لیے مائیکروفون تک رسائی کی اجازت دیں',
  dictation_unavailable: 'ڈکٹیشن اس وقت دستیاب نہیں ہے',
  questions_back: 'واپس',
  questions_next: 'اگلا',
  questions_send: 'بھیجیں',
  questions_type_answer: 'میں خود لکھوں گا',
  questions_answer_placeholder: 'اپنا جواب لکھیں…',
  close_conversation_title: 'گفتگو بند کریں',
  close_conversation_description: 'کیا آپ واقعی یہ گفتگو بند کرنا چاہتے ہیں؟',
  close_conversation_cancel: 'نہیں',
  close_conversation_confirm: 'ہاں',
  dialog_close: 'بند کریں',
  zoom_in: 'زوم اِن',
  zoom_out: 'زوم آؤٹ',
  reset_zoom: 'زوم دوبارہ ترتیب دیں',
  support_chat_aria_label: 'سپورٹ چیٹ',
};
